import { makeAutoObservable } from "mobx";
import { observer } from "mobx-react-lite";
import * as React from "react";
import { useParams } from "react-router-dom";
import { BreadcrumbItem } from "src/appStore";
import { loadCatalog, updateCatalog } from "src/business/catalog/apiCatalog";
import { ZCatalog } from "src/business/catalog/ZCatalog";
import { mdmBreadcrumbs } from "src/common/mdmBreadcrumbs";
import { onError } from "src/common/onError";
import { RemoteData } from "src/common/RemoteData";
import { LoaderBox } from "src/components/LoaderBox";
import { msgQueueStore } from "src/components/MsgQueue";
import { PageLayout } from "src/components/PageLayout";

import {
  CatalogCardStore,
  ManagementCatalogCard,
} from "./ManagementCatalogCard";
import {
  CatalogCardValues,
  edit2catalog,
} from "./ManagementCatalogCard/CatalogCardValues";

export const ManagementCatalogEdit: React.FC = observer(() => {
  const { id = "" } = useParams();
  React.useEffect(() => {
    pageStore.init(id).catch(onError);
  }, [id]);
  return (
    <PageLayout title={pageStore.crumbs}>
      <LoaderBox
        remoteData={pageStore.data}
        drawReady={(data) => <Inner data={data} />}
      />
    </PageLayout>
  );
});

const Inner: React.FC<{ data: ZCatalog }> = observer(({ data }) => (
  <ManagementCatalogCard
    title={pageStore.title}
    okText="Сохранить"
    srcData={data}
    cardStore={pageStore.cardStore}
    submit={(values) => pageStore.submit(values)}
    onSuccess={() =>
      msgQueueStore.add({
        type: "success",
        message: "Данные сохранены",
      })
    }
  />
));

const pageStore = makeAutoObservable({
  async init(catalogId: string) {
    try {
      this.setCatalogId(catalogId);
      this.setData({ status: "wait" });
      const result = await loadCatalog(catalogId);
      this.setData({ status: "ready", result });
    } catch (error) {
      this.setData({ status: "error", error });
    }
  },
  catalogId: "",
  setCatalogId(id: string) {
    this.catalogId = id;
  },
  cardStore: new CatalogCardStore(),
  data: { status: "none" } as RemoteData<ZCatalog>,
  setData(newData: RemoteData<ZCatalog>) {
    this.data = newData;
  },
  get title(): string {
    const { data } = this;
    return data.status === "ready" ? data.result.name : "...";
  },
  get crumbs(): BreadcrumbItem[] {
    return mdmBreadcrumbs([
      { type: "ObjAndSpecs", disabled: true },
      { type: "AdminCatalogs" },
      { type: "Name", name: this.title },
    ]);
  },
  async submit(values: CatalogCardValues): Promise<ZCatalog> {
    const data = edit2catalog(values);
    const result = await updateCatalog(pageStore.catalogId, data);
    this.setData({ status: "ready", result });
    return result;
  },
});
